import React from 'react';
import CircularGallery from './CircularGallery';
import './Gallery.css';

// Import gallery images
import img1 from '../assets/images/gallery/IMG-20240615-WA0135.jpg';
import img2 from '../assets/images/gallery/IMG-20240918-WA0135.jpg';
import img3 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 8.18.31 PM (1).jpeg';
import img4 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 8.18.31 PM (2).jpeg';
import img5 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 8.18.31 PM (3).jpeg';
import img6 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 8.18.31 PM.jpeg';
import img7 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 8.18.32 PM (1).jpeg';
import img8 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 8.18.32 PM (2).jpeg';
import img9 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 8.18.32 PM.jpeg';
import img10 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 8.18.33 PM.jpeg';
import img11 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 9.07.07 PM (1).jpeg';
import img12 from '../assets/images/gallery/WhatsApp Image 2025-08-28 at 9.07.07 PM.jpeg';
import img13 from '../assets/images/gallery/WhatsApp Image 2026-01-20 at 10.50.45 PM.jpeg';
import img14 from '../assets/images/gallery/WhatsApp Image 2026-02-09 at 8.43.23 PM.jpeg';
import img15 from '../assets/images/gallery/WhatsApp Image 2026-02-09 at 8.43.24 PM (1).jpeg';
import img16 from '../assets/images/gallery/WhatsApp Image 2026-02-09 at 8.43.24 PM.jpeg';

const Gallery = () => {
    // Responsive scroll settings based on screen width
    const getScrollSettings = () => {
        const width = window.innerWidth;
        if (width >= 1920) {
            return { scrollSpeed: 2, scrollEase: 0.05 };
        } else if (width >= 1200) {
            return { scrollSpeed: 1.8, scrollEase: 0.06 };
        } else if (width >= 768) {
            return { scrollSpeed: 1.5, scrollEase: 0.07 };
        } else {
            return { scrollSpeed: 1.2, scrollEase: 0.08 };
        }
    };

    const { scrollSpeed, scrollEase } = getScrollSettings();

    const galleryItems = [
        { image: img1, text: '' },
        { image: img2, text: '' },
        { image: img3, text: '' },
        { image: img4, text: '' },
        { image: img5, text: '' },
        { image: img6, text: '' },
        { image: img7, text: '' },
        { image: img8, text: '' },
        { image: img9, text: '' },
        { image: img10, text: '' },
        { image: img11, text: '' },
        { image: img12, text: '' },
        { image: img13, text: '' },
        { image: img14, text: '' },
        { image: img15, text: '' },
        { image: img16, text: '' }
    ];

    return (
        <section id="gallery" className="section">
            <div className="gallery-container">
                <div className="gallery-heading-wrapper">
                    <h2>Gallery</h2>
                    <p className="gallery-subtitle">learning, growing and moving forward in life</p>
                </div>
                <div className="gallery-carousel-wrapper">
                    <CircularGallery 
                        items={galleryItems}
                        bend={1}
                        textColor="#ffffff"
                        borderRadius={0.05}
                        scrollSpeed={scrollSpeed}
                        scrollEase={scrollEase}
                    />
                </div>
            </div>
        </section>
    );
};

export default Gallery;
